export class Constants {
  public static Colors = class {
    public static readonly IS_LIGHT_BRIGHTNESS_THRESHOLD = 0.78;
  }
}
